import { render, staticRenderFns } from "./PendingRemittances.vue?vue&type=template&id=4ca1af7c&"
import script from "./PendingRemittances.vue?vue&type=script&lang=js&"
export * from "./PendingRemittances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports